import Checkbox, { CheckboxProps } from 'antd/es/checkbox';

export interface CustomCheckboxProps extends CheckboxProps {
  label?: string | React.ReactNode;
  name?: string;
  error?: string;
}

export const CustomCheckbox = ({
  label,
  onChange,
  name = 'checkbox-name',
  error,
  ...checkboxProps
}: CustomCheckboxProps) => {
  return (
    <div className="flex flex-col">
      <Checkbox
        style={{ lineHeight: 'initial' }}
        onChange={onChange}
        name={name}
        {...checkboxProps}
      >
        {label}
      </Checkbox>
      {error && (
        <p className="mt-1 text-sm text-[12px] text-error-red">
          {error[0].toUpperCase() + error.substring(1)}
        </p>
      )}
    </div>
  );
};
